import * as React from 'react';

// Types
import { IQuestion } from './AppNetworkQuestions';

// Components
import Box from '../../components/Box';
import { DoughnutChart } from '../../components/Chart';

// Component
interface IProps {
    question: IQuestion;
    style?: React.CSSProperties;
}

function QuestionDialogAnswers(props: IProps) {

    const recipients = props.question.options.map(item => item.recipientCount);
    const answeredRecipients = recipients.reduce((pv, cv) => pv + cv, 0);
    const pendingRecipients = props.question.recipientCount - answeredRecipients;
    const backgroundColor = ['#36a2eb', '#ffce56', '#e4e4e4'];

    return (
        <Box pt={3} style={props.style}>
            <DoughnutChart
                data={{
                    labels: [...props.question.options.map(item => item.value), 'Pending'],
                    datasets: [{
                        data: [...recipients, pendingRecipients],
                        backgroundColor
                    }]
                }}
            />
        </Box>
    );
}

// Exports
export default QuestionDialogAnswers;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkQuestions/QuestionDialogResponse.tsx